import { addDays, isBefore, isSameDay } from 'date-fns';
import type { IsoDateString } from 'walden-fast/types/fast-backend/api-interface';
import type {
  EmissionDetail,
  EmissionDetailData,
} from 'walden-fast/types/fast-backend/emissions';
import type { Factory } from 'walden-fast/types/mocks';

const MOCK_EMISSION_DETAIL_DATA: EmissionDetailData = {
  emissionDetails: [
    {
      dateInIso8601: '2025-03-03',
      totalNumberShipments: 1,
      totalCO2Tonnes: 2,
      totalDistancekm: 3,
    },
  ],
  totalNumberOfShipments: 1,
  totalCO2: 2,
  totalDistanceKm: 3,
};

const MOCK_EMISSION_DETAIL: EmissionDetail = {
  dateInIso8601: '2025-02-23',
  totalNumberShipments: 1,
  totalCO2Tonnes: 2,
  totalDistancekm: 3,
};

export const emissionDetailDataFactory: Factory<EmissionDetailData> = (
  overrides,
) => ({
  ...MOCK_EMISSION_DETAIL_DATA,
  ...overrides,
});

export const emissionDetailFactory: Factory<EmissionDetail> = (overrides) => ({
  ...MOCK_EMISSION_DETAIL,
  ...overrides,
});

export const emissionDetailDataFrom = (startDate: Date) => {
  const result: EmissionDetailData = {
    emissionDetails: emissionDetailsFrom(startDate),
    totalNumberOfShipments: 1,
    totalCO2: 2,
    totalDistanceKm: 3,
  };

  return result;
};

export const emissionDetailsFrom = (startDate: Date) => {
  const result: EmissionDetail[] = [];
  let currentDate = new Date(startDate);
  const today = new Date();

  const startValue = Math.floor(Math.random() * PSEUDO_RANDOM_VALUES.length);

  while (isBefore(currentDate, today) || isSameDay(currentDate, today)) {
    const nextIndex =
      (startValue + (result.length - 1)) % PSEUDO_RANDOM_VALUES.length;
    const randomValue =
      (PSEUDO_RANDOM_VALUES[nextIndex] as number) +
      Math.floor(Math.random() * 5 - 2);

    result.push(
      emissionDetailFactory({
        dateInIso8601: new Date(currentDate)
          .toISOString()
          .split('T')[0] as IsoDateString,
        totalNumberShipments: Math.max(0, randomValue),
        totalCO2Tonnes: Math.max(0, randomValue),
        totalDistancekm: Math.max(0, randomValue),
      }),
    );
    currentDate = addDays(currentDate, 1);
  }

  return result;
};

const PSEUDO_RANDOM_VALUES = [
  17, 21, 25, 20, 15, 20, 19, 18, 20, 19, 17, 21, 23, 24, 23, 19, 17, 18, 16,
  16, 12, 7, 7, 5, 9, 11, 8, 7, 9, 6, 5, 5, 5, 5, 5, 6, 6, 5, 5, 5, 5, 6, 5, 6,
  5, 5, 6, 11, 14, 16, 14, 13, 12, 8, 8, 8, 9, 13, 8, 6, 5, 8, 5, 8, 10, 13, 9,
  14, 11, 14, 19, 18, 15, 20, 23, 20, 24, 25, 22, 25, 20, 20, 21, 20, 22, 18,
  21, 19, 22, 25, 21, 18, 13, 8, 8, 11, 16, 21, 21, 22,
];
